import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('device', [
    'cachedDevices',
    'cachedDevicesWithFilters',
    'selectedDevice',
  ]),
}

export const Methods = mapActions('device', [
  'fetchDevices',
  'selectDevice',
  'updateDevice',
  'deviceById',
])
